import { getClickId } from './getClickId';

/**
 * Generates a label string based on the provided URL values, path name, and optional prefix.
 *
 * @param urlValues - A record containing key-value pairs extracted from the URL.
 * @param pathNamePrepared - A string representing the prepared path name.
 * @param pref - An optional prefix to prepend to the label. Defaults to null.
 * @returns A formatted label string in the form `{prefix_clickId}`.
 */
export function getLabel(urlValues: Record<string, string>, pathNamePrepared: string, pref?: string | null) {
  const definedPref = pref ? `${pref}_` : '';
  const clickId = getClickId(urlValues, pathNamePrepared);

  return `{${definedPref}${clickId}}`;
}
